module.exports = __webpack_public_path__ + "img/new-next-btn-w.e7921b74.svg";